import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAngleLeft,
  faAngleRight,
  faArrowUp,
  faCamera,
  faCar,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faClipboardList,
  faDownload,
  faEnvelope,
  faExclamationCircle,
  faEye,
  faEyeSlash,
  faLink,
  faListUl,
  faMapMarkerAlt,
  faPaw,
  faPhoneAlt,
  faSearch,
  faShareAlt,
  faSlidersH,
  faTimes,
  faStar,
  faUser,
  faTrash,
  faBan,
  faCaretRight
} from "@fortawesome/free-solid-svg-icons";
import {
  faLinkedin,
  faLinkedinIn,
  faYoutube
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

/* Custom icons */
import {
  faBedAlt,
  faBluePrint,
  faEmbed,
  faFacebook,
  faLandDimensions,
  faOffice,
  faPortfolio,
  faPrinter,
  faSecurityCamera,
  faShower,
  faWhatsapp
} from "./icons";

library.add(
  faAngleLeft,
  faAngleRight,
  faArrowUp,
  faBedAlt,
  faBluePrint,
  faCamera,
  faCar,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faClipboardList,
  faDownload,
  faEmbed,
  faEnvelope,
  faExclamationCircle,
  faEye,
  faEyeSlash,
  faFacebook,
  faLandDimensions,
  faLink,
  faListUl,
  faMapMarkerAlt,
  faOffice,
  faPaw,
  faPhoneAlt,
  faPortfolio,
  faPrinter,
  faSearch,
  faSecurityCamera,
  faShareAlt,
  faShower,
  faSlidersH,
  faStar,
  faTrash,
  faBan,
  faTimes,
  faUser,
  faWhatsapp,
  faLinkedin,
  faLinkedinIn,
  faYoutube
);

Vue.component("vue-fontawesome", FontAwesomeIcon);
